<template>
  <v-main v-resize="onResize" class="pt-0">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="d-flex pa-1 bg" outlined>
            <div class="mr-auto d-flex">
              <date-time-range-picker-neo v-model="datetimes"></date-time-range-picker-neo>
              <v-divider class="ml-3 mr-2" vertical></v-divider>
              <v-select v-model="type" :items="types" class="mx-1" return-object solo dense hide-details></v-select>
              <v-divider v-if="type.value == 'R'" class="ml-3 mr-2" vertical></v-divider>
              <div v-if="type.value == 'R'" class="d-flex mt-1">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-text-field
                  v-model="report" :placeholder="this.$t('unulst.filter.report')"
                  class="text-full-width" outlined dense hide-details
                />
              </div>
              <v-divider v-if="type.value == 'T'" class="ml-3 mr-2" vertical></v-divider>
              <div v-if="type.value == 'T'" class="d-flex mt-1">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-text-field
                  v-model="tcode" :placeholder="this.$t('unulst.filter.tcode')"
                  class="text-full-width" outlined dense hide-details
                />
              </div>
              <v-divider class="ml-3 mr-2" vertical></v-divider>
              <v-checkbox v-model="cbo" :label="this.$t('hist.cbo.only')" dense hide-details></v-checkbox>
              <v-divider class="ml-3 mr-2" vertical></v-divider>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-select v-model="selectedTaskTypes" :items="taskTypes" item-text="nm" item-value="id"
                :label="$t('motlet.taskType')" multiple outlined dense :hide-details="true"
                :menu-props="{ offsetY: true }" :style="{ width: '430px', marginLeft: '6px' }">
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleTaskType">
                    <v-list-item-action>
                      <v-icon>{{ iconTaskType }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('common.select.all') }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
              <v-btn @click="fetch" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-loupe</v-icon>
              </v-btn>
            </div>
            <div>
              <download-button :loading="downloading.all" :disabled="disableDownload" @download="download('all')"></download-button>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row :style="{ height: height, overflow: 'auto' }">
        <v-col cols="3">
          <div class="mr-auto d-flex">
            <h3 class="top-title">
              <v-icon>mdi-circle-medium</v-icon>
              {{ $t('topmem.ttl.memsum', { cboStr: cboString }) }}
            </h3>
            <v-spacer></v-spacer>
            <div class="d-flex mt-1">
              <v-btn @click="fetchInner('memsum')" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <download-button :loading="downloading.memsum" :disabled="disableDownloadMemsum" @download="download('memsum')"></download-button>
            </div>
          </div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            :headers="headers.memsum" :items="items.memsum" item-key="rank"
            :items-per-page="paging.memsum.rowsPerPage" :loading="loading.memsum"
            :height="480" class="elevation-1 content"
            fixed-header dense hide-default-footer single-select
            @click:row="highlight" @contextmenu:row="showContextMenu"
          >
            <template #item.tcrp="{ item }">
              <v-tooltip content-class="tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.tcrp }}</span>
                </template>
                <span small>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template #item.cnt="{ value }">{{ value | comma }}</template>
            <template #item.avgBytes="{ value }">{{ value | bytes }}</template>
            <template #footer>
              <pagination :paging.sync="paging.memsum" :length="length.memsum" :disabled="loading.memsum"></pagination>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="3">
          <div class="mr-auto d-flex">
            <h3 class="top-title">
              <v-icon>mdi-circle-medium</v-icon>
              {{ $t('topmem.ttl.usedbytes', { cboStr: cboString }) }}
            </h3>
            <v-spacer></v-spacer>
            <div class="d-flex mt-1">
              <v-btn @click="fetchInner('usedbytes')" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <download-button :loading="downloading.usedbytes" :disabled="disableDownloadUsedbytes" @download="download('usedbytes')"></download-button>
            </div>
          </div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            :headers="headers.usedbytes" :items="items.usedbytes" item-key="rank"
            :items-per-page="paging.usedbytes.rowsPerPage" :loading="loading.usedbytes"
            :height="480" class="elevation-1 content"
            must-sort fixed-header dense hide-default-footer single-select
            @click:row="highlight" @contextmenu:row="showContextMenu"
          >
            <template #item.tcrp="{ item }">
              <v-tooltip content-class="tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.tcrp }}</span>
                </template>
                <span small>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template #item.cnt="{ value }">{{ value | comma }}</template>
            <template #item.avgBytes="{ value }">{{ value | bytes }}</template>
            <template #footer>
              <pagination :paging.sync="paging.usedbytes" :length="length.usedbytes" :disabled="loading.usedbytes"></pagination>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="3">
          <div class="mr-auto d-flex">
            <h3 class="top-title">
              <v-icon>mdi-circle-medium</v-icon>
              {{ $t('topmem.ttl.maxpage', { cboStr: cboString }) }}
            </h3>
            <v-spacer></v-spacer>
            <div class="d-flex mt-1">
              <v-btn @click="fetchInner('maxpage')" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <download-button :loading="downloading.maxpage" :disabled="disableDownloadMaxpage" @download="download('maxpage')"></download-button>
            </div>
          </div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            :headers="headers.maxpage" :items="items.maxpage" item-key="rank"
            :items-per-page="paging.maxpage.rowsPerPage" :loading="loading.maxpage"
            :height="480" class="elevation-1 content"
            must-sort fixed-header dense hide-default-footer single-select
            @click:row="highlight" @contextmenu:row="showContextMenu"
          >
            <template #item.tcrp="{ item }">
              <v-tooltip content-class="tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.tcrp }}</span>
                </template>
                <span small>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template #item.cnt="{ value }">{{ value | comma }}</template>
            <template #item.avgBytes="{ value }">{{ value | comma }}</template>
            <template #footer>
              <pagination :paging.sync="paging.maxpage" :length="length.maxpage" :disabled="loading.maxpage"></pagination>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="3">
          <div class="mr-auto d-flex">
            <h3 class="top-title">
              <v-icon>mdi-circle-medium</v-icon>
              {{ $t('topmem.ttl.privsum', { cboStr: cboString }) }}
            </h3>
            <v-spacer></v-spacer>
            <div class="d-flex mt-1">
              <v-btn @click="fetchInner('privsum')" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <download-button :loading="downloading.privsum" :disabled="disableDownloadPrivsum" @download="download('privsum')"></download-button>
            </div>
          </div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            :headers="headers.privsum" :items="items.privsum" item-key="rank"
            :items-per-page="paging.privsum.rowsPerPage" :loading="loading.privsum"
            :height="480" class="elevation-1 content"
            must-sort fixed-header dense hide-default-footer single-select
            @click:row="highlight" @contextmenu:row="showContextMenu"
          >
            <template #item.tcrp="{ item }">
              <v-tooltip content-class="tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.tcrp }}</span>
                </template>
                <span small>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template #item.cnt="{ value }">{{ value | comma }}</template>
            <template #item.avgBytes="{ value }">{{ value | bytes }}</template>
            <template #footer>
              <pagination :paging.sync="paging.privsum" :length="length.privsum" :disabled="loading.privsum"></pagination>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="3">
          <div class="mr-auto d-flex">
            <h3 class="top-title">
              <v-icon>mdi-circle-medium</v-icon>
              {{ $t('topmem.ttl.maxroll', { cboStr: cboString }) }}
            </h3>
            <v-spacer></v-spacer>
            <div class="d-flex mt-1">
              <v-btn @click="fetchInner('maxroll')" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <download-button :loading="downloading.maxroll" :disabled="disableDownloadMaxroll" @download="download('maxroll')"></download-button>
            </div>
          </div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            :headers="headers.maxroll" :items="items.maxroll" item-key="rank"
            :items-per-page="paging.maxroll.rowsPerPage" :loading="loading.maxroll"
            :height="480" class="elevation-1 content"
            must-sort fixed-header dense hide-default-footer single-select
            @click:row="highlight" @contextmenu:row="showContextMenu"
          >
            <template #item.report="{ item }">
              <v-tooltip content-class="tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.tcrp }}</span>
                </template>
                <span small>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template #item.cnt="{ value }">{{ value | comma }}</template>
            <template #item.avgBytes="{ value }">{{ value | bytes }}</template>
            <template #footer>
              <pagination :paging.sync="paging.maxroll" :length="length.maxroll" :disabled="loading.maxroll"></pagination>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="3">
          <div class="mr-auto d-flex">
            <h3 class="top-title">
              <v-icon>mdi-circle-medium</v-icon>
              {{ $t('topmem.ttl.maxbytes', { cboStr: cboString }) }}
            </h3>
            <v-spacer></v-spacer>
            <div class="d-flex mt-1">
              <v-btn @click="fetchInner('maxbytes')" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <download-button :loading="downloading.maxbytes" :disabled="disableDownloadMaxbytes" @download="download('maxbytes')"></download-button>
            </div>
          </div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            :headers="headers.maxbytes" :items="items.maxbytes" item-key="rank"
            :items-per-page="paging.maxbytes.rowsPerPage" :loading="loading.maxbytes"
            :height="480" class="elevation-1 content"
            must-sort fixed-header dense hide-default-footer single-select
            @click:row="highlight" @contextmenu:row="showContextMenu"
          >
            <template #item.tcrp="{ item }">
              <v-tooltip content-class="tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.tcrp }}</span>
                </template>
                <span small>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template #item.cnt="{ value }">{{ value | comma }}</template>
            <template #item.avgBytes="{ value }">{{ value | bytes }}</template>
            <template #footer>
              <pagination :paging.sync="paging.maxbytes" :length="length.maxbytes" :disabled="loading.maxbytes"></pagination>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="3">
          <div class="mr-auto d-flex">
            <h3 class="top-title">
              <v-icon>mdi-circle-medium</v-icon>
              {{ $t('topmem.ttl.maxbytesdi', { cboStr: cboString }) }}
            </h3>
            <v-spacer></v-spacer>
            <div class="d-flex mt-1">
              <v-btn @click="fetchInner('maxbytesdi')" color="primary" class="ml-2" x-small>
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
              <download-button :loading="downloading.maxbytesdi" :disabled="disableDownloadMaxbytesdi" @download="download('maxbytesdi')"></download-button>
            </div>
          </div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            :headers="headers.maxbytesdi" :items="items.maxbytesdi" item-key="rank"
            :items-per-page="paging.maxbytesdi.rowsPerPage" :loading="loading.maxbytesdi"
            :height="480" class="elevation-1 content"
            must-sort fixed-header dense hide-default-footer single-select
            @click:row="highlight" @contextmenu:row="showContextMenu"
          >
            <template #item.tcrp="{ item }">
              <v-tooltip content-class="tooltip" right>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ item.tcrp }}</span>
                </template>
                <span small>{{ item.description }}</span>
              </v-tooltip>
            </template>
            <template #item.cnt="{ value }">{{ value | comma }}</template>
            <template #item.avgBytes="{ value }">{{ value | bytes }}</template>
            <template #footer>
              <pagination :paging.sync="paging.maxbytesdi" :length="length.maxbytesdi" :disabled="loading.maxbytesdi"></pagination>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-menu v-model="showMenu" :position-x="x" :position-y="y" z-index="10" absolute offset-y>
        <v-list>
          <v-list-item v-for="(menu, index) in menus" :key="index" @click="openViewer(menu.id)" link>
            <v-list-item-title>{{ menu.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-container>
  </v-main>
</template>

<script>
import { mapState } from 'vuex';
import { startOfDay } from 'date-fns';
import { api } from '@/api/common/instances';
import { TASK_TYPES } from '@/constants';

export default {
  data() {
    return {
      /* search condition */
      datetimes: [startOfDay(new Date()), new Date()],
      types: [
        { text: this.$t('toplst.type.report'), value: 'R' },
        { text: this.$t('toplst.type.tcode'), value: 'T' },
      ],
      type: { text: this.$t('toplst.type.report'), value: 'R' },
      cbo: true,
      taskTypes: TASK_TYPES(),
      selectedTaskTypes: ['1'],
      report: '',
      tcode: '',
      /* download */
      downloading: {
        all: false,
        memsum: false,
        usedbytes: false,
        maxpage: false,
        privsum: false,
        maxroll: false,
        maxbytes: false,
        maxbytesdi: false,
      },
      /* table */
      length: {
        memsum: 0,
        usedbytes: 0,
        maxpage: 0,
        privsum: 0,
        maxroll: 0,
        maxbytes: 0,
        maxbytesdi: 0,
      },
      paging: {
        memsum: { page: 1, rowsPerPage: 20 },
        usedbytes: { page: 1, rowsPerPage: 20 },
        maxpage: { page: 1, rowsPerPage: 20 },
        privsum: { page: 1, rowsPerPage: 20 },
        maxroll: { page: 1, rowsPerPage: 20 },
        maxbytes: { page: 1, rowsPerPage: 20 },
        maxbytesdi: { page: 1, rowsPerPage: 20 },
      },
      loading: {
        memsum: false,
        usedbytes: false,
        maxpage: false,
        privsum: false,
        maxroll: false,
        maxbytes: false,
        maxbytesdi: false,
      },
      height: '',
      items: {
        memsum: [],
        usedbytes: [],
        maxpage: [],
        privsum: [],
        maxroll: [],
        maxbytes: [],
        maxbytesdi: [],
      },
      /* context menu */
      showMenu: false,
      menus: [{ id: 'PGM', title: this.$t('toplst.ttl.ctxt.menu.pgm'), disabled: false }],
      x: 0,
      y: 0,
      ctxtClickedItem: {},
      // API
      url: null,
      params: null,
    };
  },
  computed: {
    ...mapState('common/system', ['system']),
    cmmnHdr() {
      return [
        { text: this.$t('toplst.ttl.rank'), value: 'rank', sortable: false, width: '50px', align: 'end' },
        { text: this.type.value === 'T' ? this.$t('toplst.ttl.tcode') : this.$t('toplst.ttl.rpt'), value: 'tcrp', sortable: false, align: 'start' },
      ];
    },
    headers() {
      return {
        memsum: [...this.cmmnHdr, { text: this.$t('topmem.ttl.avg.bytes'), value: 'avgBytes', sortable: false, width: '160px', align: 'end' }],
        usedbytes: [...this.cmmnHdr, { text: this.$t('topmem.ttl.avg.bytes'), value: 'avgBytes', sortable: false, width: '160px', align: 'end' }],
        maxpage: [...this.cmmnHdr, { text: this.$t('topmem.ttl.avg.pages'), value: 'avgBytes', sortable: false, width: '160px', align: 'end' }],
        privsum: [...this.cmmnHdr, { text: this.$t('topmem.ttl.avg.bytes'), value: 'avgBytes', sortable: false, width: '160px', align: 'end' }],
        maxroll: [...this.cmmnHdr, { text: this.$t('topmem.ttl.avg.bytes'), value: 'avgBytes', sortable: false, width: '160px', align: 'end' }],
        maxbytes: [...this.cmmnHdr, { text: this.$t('topmem.ttl.avg.bytes'), value: 'avgBytes', sortable: false, width: '160px', align: 'end' }],
        maxbytesdi: [...this.cmmnHdr, { text: this.$t('topmem.ttl.avg.bytes'), value: 'avgBytes', sortable: false, width: '160px', align: 'end' }],
      };
    },
    cboString() {
      return this.cbo ? 'CBO' : '';
    },
    disableDownload() {
      // eslint-disable-next-line prettier/prettier
      return this.items.memsum.length != 0 || this.items.usedbytes.length != 0 || this.items.maxpage.length != 0
          || this.items.memsum.length != 0 || this.items.usedbytes.length != 0 || this.items.maxpage.length != 0
          || this.items.maxbytesdi.length != 0 ? false : true;
    },
    disableDownloadMemsum() {
      return this.items.memsum.length == 0 ? true : false;
    },
    disableDownloadUsedbytes() {
      return this.items.usedbytes.length == 0 ? true : false;
    },
    disableDownloadMaxpage() {
      return this.items.maxpage.length == 0 ? true : false;
    },
    disableDownloadPrivsum() {
      return this.items.privsum.length == 0 ? true : false;
    },
    disableDownloadMaxroll() {
      return this.items.maxroll.length == 0 ? true : false;
    },
    disableDownloadMaxbytes() {
      return this.items.maxbytes.length == 0 ? true : false;
    },
    disableDownloadMaxbytesdi() {
      return this.items.maxbytesdi.length == 0 ? true : false;
    },
    likesAllTaskType() {
      return this.selectedTaskTypes.length === this.taskTypes.length;
    },
    likesSomeTaskType() {
      return this.selectedTaskTypes.length > 0;
    },
    iconTaskType() {
      if (this.likesAllTaskType) return 'mdi-close-box';
      if (this.likesSomeTaskType) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  watch: {
    $route: {
      handler: 'onChangeRouteHandler',
    },
    'paging.memsum': {
      deep: true,
      handler() {
        this.fetchInner('memsum');
      },
    },
    'paging.maxroll': {
      deep: true,
      handler() {
        this.fetchInner('maxroll');
      },
    },
    'paging.maxpage': {
      deep: true,
      handler() {
        this.fetchInner('maxpage');
      },
    },
    'paging.maxbytes': {
      deep: true,
      handler() {
        this.fetchInner('maxbytes');
      },
    },
    'paging.maxbytesdi': {
      deep: true,
      handler() {
        this.fetchInner('maxbytesdi');
      },
    },
    'paging.usedbytes': {
      deep: true,
      handler() {
        this.fetchInner('usedbytes');
      },
    },
    'paging.privsum': {
      deep: true,
      handler() {
        this.fetchInner('privsum');
      },
    },
    'type.value': {
      handler: 'resetData',
    },
    cbo: {
      handler: 'resetData',
    },
    selectedTaskTypes: {
      handler: 'resetData',
    },
  },
  methods: {
    resetData() {
      Object.keys(this.items).forEach(k => {
        this.items[k] = [];
        this.length[k] = 0;
      });
    },
    toggleTaskType() {
      this.$nextTick(() => {
        if (this.likesAllTaskType) {
          this.selectedTaskTypes = [];
        } else {
          this.selectedTaskTypes = this.taskTypes.map(taskType => taskType.id);
        }
      });
    },
    onChangeRouteHandler() {
      this.fetch();
    },
    makeFetchParams(urlSuffix) {
      const params = {
        srchBgnYmdhms: this.datetimes[0].getTime(),
        srchEndYmdhms: this.datetimes[1].getTime(),
        sstmId: this.system.id,
      };
      params.type = this.type.value;
      params.report = this.report;
      params.tcode = this.tcode;
      params.exOwlens = true;
      params.exSystem = true;
      params.taskTypes = this.selectedTaskTypes.toString();
      params.cboOnly = this.cbo;

      this.url = `/statistics/top-memory-list${urlSuffix}`;
      this.params = params;
    },
    async fetch() {
      await this.fetchInner('memsum');
      await this.fetchInner('usedbytes');
      await this.fetchInner('maxpage');
      await this.fetchInner('privsum');
      await this.fetchInner('maxroll');
      await this.fetchInner('maxbytes');
      await this.fetchInner('maxbytesdi');
    },
    async fetchInner(kind) {
      this.loading[kind] = true;
      this.makeFetchParams('');
      const params = this.params;
      params.kind = kind;
      params.page = this.paging[kind].page;
      params.limit = this.paging[kind].rowsPerPage;
      const {
        data: { items, pagination },
      } = await api.get(this.url, { params });
      this.items[kind] = items;
      this.length[kind] = pagination.totalCount;
      this.loading[kind] = false;
    },
    download(kind) {
      this.downloading[kind] = true;
      this.makeFetchParams('-excel');
      const params = this.params;
      params.kind = kind;
      // eslint-disable-next-line prettier/prettier
      api.get(this.url, {params, responseType: 'blob'})
        .then(({ data, headers }) => {
        let filename = '';
        const disposition = headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
        }
        const type = headers['content-type'];
        const blob = new Blob([data], { type: type });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);
          if (filename) {
            const a = document.createElement('a');
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl;
            } else {
              a.href = downloadUrl;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
            }
          } else {
            window.location = downloadUrl;
          }
          setTimeout(() => URL.revokeObjectURL(downloadUrl), 100); // cleanup
        }
        this.downloading[kind] = false;
      });
    },
    highlight(item, { isSelected, select }) {
      select(!isSelected);
    },
    /**
     * 테이블 row 우클릭 시 context menu 보여주기
     */
    showContextMenu(e, { item }) {
      e.preventDefault();
      this.ctxtClickedItem = item;
      this.x = e.clientX;
      this.y = e.clientY;
      this.showMenu = true;
    },
    /**
     * Context menu 선택 시 해당 화면 띄우기
     */
    openViewer(id) {
      let url, params;

      if (id === 'PGM') {
        params = {
          typ: 'tcrp',
          sdt: this.datetimes[0].getTime(),
          edt: this.datetimes[1].getTime(),
        };
        if (this.type.value == 'R') params.rpt = this.ctxtClickedItem.tcrp;
        if (this.type.value == 'T') params.tcod = this.ctxtClickedItem.tcrp;
        url = `/views/analysis/program-history/${this.system.id}`;
      }
      window.open(`${url}?${new URLSearchParams(params).toString()}`, '_blank');
    },
    onResize() {
      this.height = `${window.innerHeight - 182}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-full-width {
  width: 190px;
  margin-bottom: 3px;
}
.v-list-item {
  min-height: 28px;
}
.top-title {
  width: 400px;
  padding: 2px 0px 10px 20px;
}
</style>
